import { useCallback } from 'react'

import CommonPage from 'app/common/templates/CommonPage'
import { IsReportEnabled, SubReportChooser, getReportTitle } from 'app/components/Reports'
import { Loading } from 'app/common/templates-next/page-template'

// TODO dataKey нужно убрать, по примеру FinancesSummary
import Accounting, { dataKey as accountingReport } from 'app/components/Reports/_Accounting'
import Balance, { dataKey as balanceReport } from 'app/components/Reports/_Balance'
import Sales, { dataKey as salesReport } from 'app/components/Reports/_Sales'
import SalesByGroupComplexes, {
  dataKey as salesByGroupComplexesReport,
} from 'app/components/Reports/_SalesByGroupComplexes'
import PurchasesByPaymentMode, {
  dataKey as purchasesByPaymentModeReport,
} from 'app/components/Reports/_PurchasesByPaymentMode'
import SalesByFunds, { dataKey as salesByFundsReport } from 'app/components/Reports/_SalesByFunds'
import Subsidies, { dataKey as subsidiesReport } from 'app/components/Reports/_Subsidies'
import Corrections, { dataKey as correctionsReport } from 'app/components/Reports/_Corrections'

import OrdersByClasses, {
  dataKey as ordersByClassesReport,
} from 'app/components/Reports/_OrdersByClasses'

import { FinancesSummary } from 'app/components/Reports/_FinancesSummary'
import { FinancesSummaryReplenishment } from 'app/components/Reports/_FinancesSummaryReplenishment'
import { FinancesSummaryWriteOff } from 'app/components/Reports/_FinancesSummaryWriteOff'
import { AverageCheck } from 'app/components/Reports/_AverageCheck'
import { ReportType } from 'app/dataTypes/reports'

import getBaseUrl from './getBaseUrl'

const rootUrl = getBaseUrl()

type Props = {
  match: {
    params: {
      report: string
      subReport?: string
    }
  }
  history: {
    push: Function
    replace: Function
  }
}

const ReportPage = ({ match, history }: Props) => {
  const {
    params: { report, subReport },
  } = match
  const { push, replace } = history

  const redirectToRoot = useCallback(() => {
    push(rootUrl)
  }, [push])

  const redirectToReport = useCallback(
    (newReport: string) => {
      replace(getBaseUrl({ report, subReport: newReport }))
    },
    [replace, report],
  )

  return (
    <CommonPage header={`Отчет: ${getReportTitle(report)}`}>
      <IsReportEnabled report={report} fallback={<Loading />} onReportDisabled={redirectToRoot}>
        <SubReportChooser
          baseUrl={getBaseUrl({ report })}
          redirectToReport={redirectToReport}
          subReport={subReport}
          report={report}
          hideBorderBottom={report === ReportType.FinancesSummary || report === subsidiesReport}
        >
          {report === accountingReport && <Accounting />}
          {report === balanceReport && <Balance />}
          {report === salesReport && <Sales />}
          {report === salesByGroupComplexesReport && <SalesByGroupComplexes />}
          {report === purchasesByPaymentModeReport && <PurchasesByPaymentMode />}
          {report === salesByFundsReport && <SalesByFunds />}
          {report === correctionsReport && <Corrections />}
          {report === ordersByClassesReport && <OrdersByClasses />}
          {report === subsidiesReport && subReport && <Subsidies subReport={subReport} />}

          {/* FinancesSummary */}
          {report === ReportType.FinancesSummary && subReport === ReportType.FinancesSummary && (
            <FinancesSummary profileLink="/profile" />
          )}
          {report === ReportType.FinancesSummary &&
            subReport === ReportType.FinancesSummaryReplenishment && (
              <FinancesSummaryReplenishment profileLink="/profile" />
            )}
          {report === ReportType.FinancesSummary &&
            subReport === ReportType.FinancesSummaryWriteOff && (
              <FinancesSummaryWriteOff profileLink="/profile" />
            )}

          {report === ReportType.AverageCheck && <AverageCheck profileLink="/profile" />}
        </SubReportChooser>
      </IsReportEnabled>
    </CommonPage>
  )
}

export default ReportPage
